import React, { useEffect, useState } from 'react';
import CaseStudyList from '../../../components/public/case-studies/CaseStudyList';
import PageHeader from '../../../components/public/common/PageHeader';
import Layout from '../../../components/public/common/Layout';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import { caseStudyService } from '../../../services/caseStudyService';

const CaseStudyListPage = () => {
  const [caseStudies, setCaseStudies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [itemsPerPage] = useState(10);

  const fetchCaseStudies = async (pageNum = 1) => {
    try {
      setLoading(true);
      setError(null);

      const response = await caseStudyService.getAllPublishedCaseStudies({
        page: pageNum,
        limit: itemsPerPage,
        sortField: 'publishedAt',
        sortOrder: 'desc'
      });

      if (!response || !response.data) {
        throw new Error('No case studies found');
      }

      const { data, pages } = response;
      
      if (pageNum === 1) {
        setCaseStudies(data);
      } else {
        setCaseStudies(prevCaseStudies => [...prevCaseStudies, ...data]);
      }

      setTotalPages(pages);
      setHasMore(pageNum < pages);
      setPage(pageNum);
    } catch (error) {
      console.error('Error fetching case studies:', error);
      setError(error.message || 'Failed to fetch case studies');
    } finally {
      setLoading(false);
    }
  };

  const loadMore = () => {
    if (!loading && hasMore) {
      fetchCaseStudies(page + 1);
    }
  };

  useEffect(() => {
    fetchCaseStudies(1);
  }, []);

  return (
    <Layout>
      <PageHeader
        title="Case Studies"
        description="Explore our portfolio of successful projects"
        backgroundImage="/images/case-studies-header.jpg"
      />
      
      {error && (
        <div className="container mx-auto px-6 py-8">
          <div className="text-red-500 text-center mb-4 dark:text-red-400">
            {error}
          </div>
        </div>
      )}

      {caseStudies.length > 0 && (
        <CaseStudyList caseStudies={caseStudies} />
      )}

      {loading && (
        <div className="flex justify-center items-center py-8">
          <LoadingSpinner size="lg" text="Loading more case studies..." />
        </div>
      )}

      {!loading && hasMore && (
        <div className="flex justify-center py-8">
          <button
            onClick={loadMore}
            className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-200"
          >
            Load More Case Studies
          </button>
        </div>
      )}

      {!loading && !hasMore && caseStudies.length > 0 && (
        <div className="text-center py-8 text-gray-600 dark:text-gray-400">
          No more case studies to load
        </div>
      )}

      {!loading && caseStudies.length === 0 && !error && (
        <div className="text-center py-8 text-gray-600 dark:text-gray-400">
          No case studies found
        </div>
      )}
    </Layout>
  );
};

export default CaseStudyListPage; 